const pagination = {
  name: 'pagination',
  data() {
    return {
      maxVisibleButtons : 10
    }
  },
  props: {
    section: {
      type: String,
      required: false,
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
  },
  mounted() {
    if(window.innerWidth < 500) {
      this.maxVisibleButtons = 5
    }
  },
  computed: {
    startPage() {
      const maxStartPage = Math.max(1, this.totalPages - this.maxVisibleButtons + 1);
      return Math.min(maxStartPage, Math.max(1, this.currentPage - 1));
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages() {
      const range = [];
      for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
        range.push({
          number: i,
          isDisabled: i === this.currentPage 
        });
      }
      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    scrollToSection(section) {
      document.getElementById(section).scrollIntoView({
        behavior: 'smooth',
      });
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
      this.section && this.scrollToSection(this.section);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
      this.section && this.scrollToSection(this.section);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
      this.section && this.scrollToSection(this.section);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
  }
};


document.querySelectorAll(".vue-fetch").forEach((el) => {
  new Vue({
      delimiters: ["[[", "]]"],
      el,
      components: {
        pagination
      },
      propsData: { ...el.dataset },
      props: {
        pagesize: {
          type: String,
          default: ""
        },
        urlapi: {
          type: String,
          default: ""
        },
        lang: {
          type: String,
          default: ""
        }
      },
      data() {
        return {
          totalItems: 0,
          urlCounter:null,
          selectedItemId: null,
          activeIndexSharer:null,
          showSocial: false,
          innerOpen: false,
          counter: 0,
          id: "1",
          nb_pages: 0,
          items: [],
          next: null,
          previous: null,
          loading: true,
          currentFilters:{},
          params: {},
          filters: {
            lang: this.lang,
            page: 1,
            search: '',
            page_size: Number(this.pagesize)
          },
        };
      },
      mounted() {
        this.setCounterUrl()
        this.$nextTick(function () {
          this.getItems();
        });
      },
      computed:{
        getClassSharer() {
          return ind => {
            if(ind == this.activeIndexSharer){
              return 'open-share tw-open-share';
            }
            return false
          }
        }
      },
      watch: {
        open(value) {
          this.innerOpen = value;
        },
        params(value) {
          this.counter = String(Object.keys(this.params).length).padStart(2, '0');
        },
        selectedItemId(newItemId){
          if (newItemId) {
            axios
              .post(this.urlCounter + newItemId)
              .then(response => {
                console.log(response.data);
              })
              .catch(error => {
                console.error(error);
              });
          }
        }
      },
      methods: {
        setCounterUrl(){
          const counterUrls = {
            insights: '/api/v1/update-counter-insights/',
            events: '/api/v1/update-counter-events/',
            podcasts: '/api/v1/update-counter-podcasts/',
            default: '/api/v1/update-counter/'
          };
          this.urlCounter = counterUrls[this.urlapi] || counterUrls.default;
        },
        selectItem(id) {
          this.selectedItemId = id;
        },
        setOpenSharer(index) { 
          if(this.activeIndexSharer == index ) {
            this.activeIndexSharer = null
          } else {
            this.activeIndexSharer = index;          
          }
        },
        sliceItems(start, end) {
          return this.items.slice(start, end);
        },
        toggleSubMenu() {
          this.innerOpen = !this.innerOpen;
        },
        startTransition(el) {
            el.style.height = el.scrollHeight + "px";
        },
        endTransition(el) {
            el.style.height = "";
        },
        getItems(search = false) {
          if(search) {
            this.filters.page = 1
          }
          axios.get( "/api/v1/" + this.urlapi, {
            params: {...this.filters, ...this.params}
          })
          .then(({data}) => {
            this.items = data.results;
            this.nb_pages = Math.ceil(data.count/this.filters.page_size);
            this.totalItems = data.count;
            this.loading = false;
          });
        },
        debounceSearch(event) {
          clearTimeout(this.debounce)
          this.debounce = setTimeout(() => {
            this.loading = true;
            this.filters.search = event.target.value
            this.getItems(true)
          }, 600)
        },
        onPageChange(page) {
          this.loading = true;
          this.filters.page = page;
          this.getItems();
        },
        updateFilter(filter, value, item) {
          Vue.set(this.params, filter, value);
          Vue.set(this.currentFilters, filter, {
            'category': filter,
            'name': item,
            'value': value,
          });
          this.getItems()
        },
        deleteFilter(filter) {
          if(filter){
            Vue.delete(this.params, filter);
            Vue.delete(this.currentFilters, filter);
            this.getItems()
          } else {
            this.params = {}
            this.currentFilters = {}
            this.getItems()
          }
        }
      }
    });
});